import ReactPDF, { Text, View } from "@react-pdf/renderer";
import { isNull } from "lodash";
import * as React from "react";

interface IProps {
  title: string;
  value: boolean | null,
  styles: ReactPDF.Styles
}

const LicenceItem = (props: IProps) => {
  const { title, value, styles } = props;

  if (isNull(value)) {
    return null;
  }

  return (
    <View style={[styles.sentence, styles.listItem]}>
      <Text style={styles.bold}>{title}: &nbsp;</Text>
      <Text>{value ? 'Yes' : 'No'}</Text>
    </View>
  )
}

export default LicenceItem;
